
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import api from "@/services/api"

const caseStore = namespace("cases")

@Component({
	components: {
	}
})
export default class CaseActions extends Vue {
	@Prop()
	public currentCase: any;

	private completedAction (action: any) {
		api.completeAction(this.currentCase.id, action.id)
	}
}

